import { render, staticRenderFns } from "./MemberEmail.vue?vue&type=template&id=635185ac&scoped=true"
import script from "./MemberEmail.vue?vue&type=script&lang=js"
export * from "./MemberEmail.vue?vue&type=script&lang=js"
import style0 from "./MemberEmail.vue?vue&type=style&index=0&id=635185ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635185ac",
  null
  
)

export default component.exports